import React from "react"
import { connect } from 'react-redux';
import TransHelper from './TransHelper';

class Translate extends React.Component {
  translate = () => {
    var transKey = this.props.children;
    var variables = this.props.variables
    return TransHelper.translate(this.props.locale, transKey, variables);
  }

  containsHtmlTags(str) {
    const htmlTagRegex = /<\/?[a-z][\s\S]*?>/i;
    return htmlTagRegex.test(str);
  }

  render() {
    var text = this.translate();
    return (
      <React.Fragment>
        {this.containsHtmlTags(text)
          ?
          <span dangerouslySetInnerHTML={{ __html: text }}></span>
          :
          text
        }
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale
  }
}

export default connect(mapStateToProps)(Translate);
